













































import { Component, Vue } from "vue-property-decorator";
import PanelGroup from "@/components/PanelGroup.vue";
import ViceBannerTable from "./components/ViceBannerTable.vue";
import ViceBannerEdit from "./components/ViceBannerEdit.vue";
import ViceBannerTitleEdit from "./components/ViceBannerTitleEdit.vue";
import { ITabModel, IPanelData } from "@/data/commonModel";
import { IMainBannerModel, IMainBannerTitleModel } from "./data/bannerModel";
// import { UserModule } from "@/store/modules/user";
import { BannerModule } from "@/store/modules/banner";
// import ViceBannerTableVue from "./components/ViceBannerTable.vue";

// 装饰器模式
@Component({
  components: {
    PanelGroup,
    ViceBannerTable,
    ViceBannerEdit,
    ViceBannerTitleEdit,
  },
})
export default class extends Vue {
  // Data
  editDialogVisible: boolean = false;
  isOrdering: boolean = false; // 是否在排序中
  editType: string = "add";
  panelObj: IPanelData = { type: "all", searchText: "" ,show:true};
  bannerModel: IMainBannerModel | null = null;

  editTitleDialogVisible: boolean = false;
  // Get
  get tabs(): ITabModel[] {
    const arr = [
      {
        title: `全部(${BannerModule.viceBannerCountRes.allCount})`,
        key: "all",
      },
      {
        title: `已发布(${BannerModule.viceBannerCountRes.publishedCount})`,
        key: "published",
      },
      {
        title: `未发布(${BannerModule.viceBannerCountRes.unpublishedCount})`,
        key: "unpublished",
      },
    ];
    return arr;
  }
  // Methods
  mounted() {
    BannerModule.FetchViceBannerCountByStatus();
  }

  // 切换选项卡
  _handleSwitchTab(props: IPanelData) {
    this.panelObj = props;
    this.isOrdering = false;
  }

  // 新建活动
  _onClickAdd() {
    this.editType = "add";
    this.bannerModel = null;
    this.editDialogVisible = true;
  }

  // 设置副banner标题
  _onClickSetTitle() {
    this.editTitleDialogVisible = true;
  }

  // 开始/取消对MP展示进行排序
  _onClickSort() {
    this.isOrdering = !this.isOrdering;
  }

  _handleEditBannerSuccess(type: string) {
    BannerModule.FetchViceBannerCountByStatus();
    const ref: ViceBannerTable = this.$refs["banner-table"] as ViceBannerTable;
    ref.refreshTable();
  }

  _handleEditBanner(value: IMainBannerModel) {
    this.editType = "edit";
    this.editDialogVisible = true;
    this.bannerModel = JSON.parse(JSON.stringify(value));
  }
}
